import {
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILURE,
  UPDATE_PROFILE_RESET,
} from "../../../redux/types/auth";

const initialState = {
  loading: false,
  message: "",
  error: "",
  success: false,
};

const updateUserProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PROFILE_REQUEST:
      return {
        loading: true,
        message: "",
        error: "",
        success: false,
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        loading: false,
        message: action.payload.message || "Profile updated successfully",
        error: "",
        success: true,
      };
    case UPDATE_PROFILE_FAILURE:
      return {
        loading: false,
        message: "",
        error: action.payload.error || "Profile update failed",
        success: false,
      };
    case UPDATE_PROFILE_RESET:
      return initialState;
    default:
      return state;
  }
};

export default updateUserProfileReducer;
